import { Search } from '@ori-ui/icons';
import { ButtonBase, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { VFC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationKeys } from '../models';
import { useNavigationContext } from '~/contexts/NavigationContext';

const SearchIconRoot = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontSize: theme.typography.pxToRem(28),
  marginRight: 'auto',

  [theme.breakpoints.up('sm')]: {
    marginRight: theme.spacing(6),
  },
}));

export const SearchIcon: VFC = () => {
  const [translate] = useTranslation();
  const { hideSearchResultsTab, toggleIsSearchInputVisible, isSearchInputVisible } =
    useNavigationContext();
  const { getTestId } = useTestId();

  const handleClick = useCallback(() => {
    toggleIsSearchInputVisible();

    if (isSearchInputVisible) {
      hideSearchResultsTab();
    }
  }, [hideSearchResultsTab, isSearchInputVisible, toggleIsSearchInputVisible]);

  return (
    <SearchIconRoot
      disableRipple
      aria-label={translate(TranslationKeys.Search)}
      data-testid={getTestId('search-icon')}
      onClick={handleClick}
    >
      <Search fontSize="inherit" />
    </SearchIconRoot>
  );
};
